module.exports = __webpack_public_path__ + "img/glass-mug.57ef038c.svg";